import utils from "../../universal/utils";

export const CAMPAIGN_ATTRIBUTION_LOADING = "CAMPAIGN_ATTRIBUTION_LOADING";
export const CAMPAIGN_ATTRIBUTION_LOADED = "CAMPAIGN_ATTRIBUTION_LOADED";
export const CAMPAIGN_ATTRIBUTION_ERROR = "CAMPAIGN_ATTRIBUTION_ERROR";

const basePath = utils.getEdgeBasePath();

async function readJsonOrThrow(response) {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  const data = await response.json();
  if (!data.ok) {
    throw new Error(data.error || data.err || "Campaign attribution request failed");
  }
  return data;
}

export const fetchCampaignAttributionSummary = ({ userId }) => {
  return async (dispatch) => {
    if (!userId) return;

    dispatch({ type: CAMPAIGN_ATTRIBUTION_LOADING });

    try {
      const data = await fetch(
        `${basePath}/api/v7/admin/campaign-attribution/summary/adpass/${userId}`,
        { credentials: "include" }
      ).then(readJsonOrThrow);

      dispatch({
        type: CAMPAIGN_ATTRIBUTION_LOADED,
        payload: {
          headlines: data.headlines,
          rows: data.rows,
        },
      });
    } catch (error) {
      console.error("Error fetching campaign attribution:", error);
      dispatch({
        type: CAMPAIGN_ATTRIBUTION_ERROR,
        payload: error.message,
      });
    }
  };
};
